import React, { useCallback, useEffect, useMemo, useRef } from 'react';

import { FlatList, ListRenderItemInfo, View } from 'react-native';

import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import i18n from 'i18next';

import CheckMarkImage from 'assets/images/svgs/ico_checkmark.svg';

import gStyles from 'config/styles';

import { selectLanguagesList } from 'store/config/selectors.app';
import { selectBackground } from 'store/config/selectors.layout';
import { getTemplateview } from 'store/railsBuilder/actions';
import { selectTemplateviewsById } from 'store/railsBuilder/selectors';
import { setLanguage } from 'store/user/actions';
import { selectLanguage } from 'store/user/selectors';

import { LanguagesNames } from 'utils/Language/languageNames';

import SettingsRowItem from '../components/RowItem';
import { SimpleSettingsItem } from '../types';

function LanguagePage() {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const currentLang = useSelector(selectLanguage);
    const languagesList = useSelector(selectLanguagesList);
    const background = useSelector(selectBackground);
    const templateviewsById = useSelector(selectTemplateviewsById);

    const updatedLanguage = useRef(currentLang);

    const listStyle = useMemo(
        () => ({
            backgroundColor: background,
        }),
        [background],
    );

    const handleChangeLanguage = useCallback(
        ({ id }: SimpleSettingsItem) => {
            i18n.changeLanguage(id);
            dispatch(setLanguage(id as LanguagesNames));
        },
        [dispatch],
    );

    const renderItem = useCallback(
        ({ item, index }: ListRenderItemInfo<SimpleSettingsItem>) => (
            <SettingsRowItem
                item={item}
                title={t(item.title)}
                onPress={handleChangeLanguage}
                RightIcon={item.id === currentLang ? CheckMarkImage : undefined}
                position={index + 1}
                total={languagesList.length}
                isSelected={item.id === currentLang}
            />
        ),
        [handleChangeLanguage, currentLang, t],
    );

    useEffect(() => {
        updatedLanguage.current = currentLang;
    }, [currentLang]);

    useEffect(() => {
        return () => {
            if (currentLang !== updatedLanguage.current) {
                Object.keys(templateviewsById).forEach((templateviewId) => {
                    dispatch(getTemplateview(templateviewId));
                });
            }
        };
    }, []);

    return (
        <View style={[gStyles.settingsContainer, listStyle]}>
            <FlatList
                style={gStyles.settingsContentContainer}
                nestedScrollEnabled
                data={languagesList}
                keyExtractor={keyExtractor}
                renderItem={renderItem}
                showsHorizontalScrollIndicator={false}
                accessibilityRole="menu"
            />
        </View>
    );
}

export default LanguagePage;

function keyExtractor(item: SimpleSettingsItem) {
    return item.id;
}
